/**
 * This is a custom hook for reading data from memory
 */

import { useState } from "react";
import Memory from "../../../service/memory/base/Memory";
import MemoryOperation from "../../../service/memory/enum/MemoryOperation";

export const useReadMemory = (memoryType, storageType) => {
    const [dataFromMemory] = useState(() => {
        const memory = new Memory();
        const data = {};
        data["key"] = memoryType;
        const result = memory.handleRequest(MemoryOperation.READ, memoryType, data);
        return result;
    });
    return dataFromMemory;
};
